import uploadcare from 'uploadcare-widget';
import uploadcareTabEffects from 'uploadcare-widget-tab-effects';

(function ($) {

    function WCProI18n(keys) {
        console.log('Custom i18n');
        console.log(keys);
        this.keys = keys || {};
    }

    WCProI18n.prototype.get = function (key) {
        console.log('Get key');
        console.log(key);
        return this.keys[key] || key;
    };

    function WCProUploadCare(options) {
        console.log('WCU initialization');
        if (!options) {
            throw new Error('No options passed to WCU constructor');
        } else if (!options.publicKey) {
            throw new Error('No public key passed to WCU constructor');
        } else if (!options.siteUrl) {
            throw new Error('No siteUrl passed to WCU constructor');
        } else if (!options.userId) {
            throw new Error('No userId passed to WCU constructor');
        }

        this.options = $.extend({}, WCProUploadCare.defaults, options);
        this.files = [];
        this.i18n = new WCProI18n(options.translations || {}); // Create i18n instance

        console.log(this.options);
        this.setup();
    }

    WCProUploadCare.prototype.setup = function () {
        let self = this;

        if (this.options.enableEffects === '1') {
            uploadcare.registerTab('preview', uploadcareTabEffects);
        }

        $('#wc-file-uploader-button').on('click', function (event) {
            event.preventDefault();
            self.showDialog(self);
        });

        $('body').on('click', '#wc-file-uploader-image', function (event) {
            event.preventDefault();
            self.showDialog(self);
        });
    };

    WCProUploadCare.prototype.showDialog = function (obj) {
        let self = obj;

        let dialog = uploadcare.openDialog(obj.files, '', {
            publicKey: self.options.publicKey,
            metadata: {
                'siteUrl': self.options.siteUrl,
                'userId': self.options.userId,
                'source': 'pro',
                'retentionPeriod': self.options.retentionPeriod
            },
            validators: [
                self.minDimensions(self.options.minWidth, self.options.minHeight)
            ]
        });

        dialog.fileColl.onAdd.add((file) => {

            if (self.options.enableShowMoreFileButton == '1') {
                if (typeof UPLOADCARE_MULTIPLE_MIN !== 'undefined' && typeof UPLOADCARE_MULTIPLE_MAX !== 'undefined') {
                    if ($('.uploadcare--button.uploadcare--button__multiple__more').length === 0) {
                        let buttonText = self.i18n.get('addMoreFiles'); // Fixed: access i18n instance
                        var newDiv = $(`<div class="uploadcare--multiple__more" style="padding: 20px">
                        <button style="width: 100%" class="uploadcare--button uploadcare--button__multiple__more">${buttonText}</button>
                    </div>`);

                        $('.uploadcare--footer.uploadcare--tab__footer').before(newDiv);

                        $('.uploadcare--button.uploadcare--button__multiple__more').on('click', function () {
                            jQuery('.needsclick').click();
                        });
                    }
                }
            }

            obj.files.push(file);
            self.checkButtonName();
            self.addDataToField();
        });

        dialog.fileColl.onRemove.add(result => {

            result.promise().done(fileInfo => {
                if (obj.files.length) {
                    $.each(obj.files, function (key, file) {

                        file.done(savedFileInfo => {
                            if (savedFileInfo.uuid === fileInfo.uuid) {
                                obj.files.splice(key, 1);
                                $.each($('.wcu-image-thumbnail'), function (imageKey, image) {
                                    // TODO: Need to check how remove files
                                    if ($(image).data('image-uuid') === fileInfo.uuid) {
                                        $(image).remove();
                                    }
                                });
                            }
                            self.checkButtonName();
                            self.addDataToField();
                        });
                    });

                    
                    setTimeout(() => {
                        if (obj.files.length < 1) {
                            let imageBlock = $('#wc-file-uploader-image');
                            let imageInput = $('#wcu-image-file');
                            let cdnUrlInput = $('#wcu-cdn-url');

                            imageBlock.empty();
                            imageInput.val('');
                            cdnUrlInput.val('');
                        }
                    }, 500);
                }

            });
        });


        dialog.done(result => {
            obj.files = [];
            if (typeof result.files !== 'undefined') {
                obj.files = result.files();
            } else {
                obj.files.push(result);
            }

            result.promise().done(fileInfo => {
                let imageBlock = $('#wc-file-uploader-image');
                let imageInput = $('#wcu-image-file');
                let cdnUrlInput = $('#wcu-cdn-url');

                imageBlock.empty();
                let fi = '';
                let fcdnurl = '';
                imageInput.val('');
                cdnUrlInput.val('');

                console.log('F-Info');
                console.log(fileInfo);

                // multiple files:
                if (typeof fileInfo.count !== 'undefined') {
                    console.log(fileInfo);
                    fi = fileInfo.uuid;
                    imageBlock.append('<a href="' + fileInfo.cdnUrl + '" target="_blank">Uploaded Files</a><br>');
                } else {
                    // single file
                    fi += fileInfo.uuid;
                    fcdnurl += fileInfo.cdnUrl;

                    if (!self.isImage(fileInfo.name)) {
                        imageBlock.append('<a href="' + fileInfo.cdnUrl + '" target="_blank">File</a>');
                    }
                }

                imageInput.val(fi);
                cdnUrlInput.val(fcdnurl);

                self.checkButtonName();
                self.addDataToField();
            });
        });
    };

    WCProUploadCare.prototype.isImage = function (url) {
        return /\.(jpg|jpeg|png|webp|avif|gif|svg|heic)$/.test(url);
    };

    WCProUploadCare.prototype.minDimensions = function (width, height) {
        return function (fileInfo) {
            var imageInfo = fileInfo.originalImageInfo;

            if (imageInfo === null) {
                return;
            }

            var heightExceeded = height && imageInfo.height < height;

            if (width && imageInfo.width < width) {
                if (heightExceeded) {
                    throw new Error('minDimensions');
                } else {
                    throw new Error('minWidth');
                }
            }

            if (heightExceeded) {
                throw new Error('minHeight');
            }
        };
    };

    WCProUploadCare.prototype.fileTypeLimit = function (types) {
        types = types.split(' ');

        return function (fileInfo) {
            if (fileInfo.name === null) {
                return;
            }

            var extension = fileInfo.name.split('.').pop();

            if (types.indexOf(extension) === -1) {
                throw new Error('fileType');
            }
        };
    };

    WCProUploadCare.prototype.addDataToField = function () {
        console.log('RUN');
        console.log(this.files);


        let imageBlock = $('#wc-file-uploader-image');
        imageBlock.empty();

        $.each(this.files, function (key, value) {

            value.done(savedFileInfo => {
                if (savedFileInfo.uuid) {
                    if (!$('.wcu-image-thumbnail[data-uc-id="' + savedFileInfo.uuid + '"]').length) {
                        imageBlock.append('<img class="wcu-image-thumbnail" data-image-name="' + savedFileInfo.name + '" src="' + savedFileInfo.cdnUrl + '/-/preview/416x216/-/quality/smart/-/format/auto/" alt="" style="margin-bottom: 5px; margin-right: 5px;" data-uc-id="' + savedFileInfo.uuid + '" data-cdn-url="' + savedFileInfo.cdnUrl + '">');
                    }
                }
            });
        });
    };

    /**
     * Changing the name of the button depending on the uploaded images
     */
    WCProUploadCare.prototype.checkButtonName = function () {
        let button = $('#wc-file-uploader-button');
        if (this.files.length > 0) {
            button.empty().append(button.data('uploaded-button-name'));
        } else {
            console.log(this.files.length);
            button.empty().append(button.data('empty-button-name'));
        }
    };

    window.WCProI18n = WCProI18n;
    window.WCProUploadCare = WCProUploadCare;

})(jQuery);